import format from 'date-fns/format'

const formatDateAppointment = (value) => {
  if (value == null || value === '') return undefined

  const date = value instanceof Date ? value : new Date(value)
  if (Number.isNaN(date.getTime())) return undefined

  return format(date, 'yyyy/MM/dd')
}

/**
 * Builds query params for GET /v1/schedules/validations.
 * Accepts legacy caller keys (`plenna_id`, `date`) and maps them to the patients API contract.
 */
export const buildScheduleValidationsQueryParams = (
  parameters = {},
  { isGuestFlowActive = false } = {}
) => {
  const plennaServiceId =
    parameters.plenna_service_id ?? parameters.plenna_id
  const dateAppointment = formatDateAppointment(
    parameters.date_appointment ?? parameters.date
  )
  const timelineId = parameters.timeline_id ?? parameters.timelineId

  const queryParams = {}

  if (plennaServiceId != null && plennaServiceId !== '') {
    queryParams.plenna_service_id = plennaServiceId
  }

  if (dateAppointment != null && dateAppointment !== '') {
    queryParams.date_appointment = dateAppointment
  }

  if (timelineId != null && timelineId !== '') {
    queryParams.timeline_id = timelineId
  }

  if (isGuestFlowActive) {
    queryParams.coming_from_guest_flow = true
  }

  return queryParams
}
